<template>
  <div class="widget" v-if="perShift && perShift.id">
    <div class="widget-title">
      <!-- <v-icon>{{ getIconByShift(shift.id) }}</v-icon> -->
      {{ perShift.name }}
    </div>
    <div class="widget-content">

      <div 
        class="widget-item monthly" 
        v-if="settings.value.show_goal"
      >
        Weekly Goal :
        <span class="value goal">
          {{ perShift[useByPaymentCapacity('weekly')].goal | numFormat(currency) }}
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div
        class="widget-item current"
        v-if="settings.value.show_current_total_value"
      >
        Current Total :
        <span class="value total">
          <template v-if="target_type === 'Amount'">
            {{ perShift[useByPaymentCapacity('weekly')][useNetAmount()] | numFormat(currency) }}
          </template>
          <template v-else>
            {{ perShift[useByPaymentCapacity('weekly')][useNetCount] | numFormat }}
          </template>
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div 
        class="widget-item per-day" 
        v-if="settings.value.show_needed_per_day"
      >
        Needed Per Day :
        <span class="value needed">
          {{ perShift[useByPaymentCapacity('daily')].goal | numFormat(currency) }}
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div 
        class="widget-item working-days" 
        v-if="settings.value.show_working_days"
      >
        Days : Working -
        <span class="value days">
          {{ perShift[useByPaymentCapacity('weekly')].days.working | dayFormat }}
        </span>
        | Left - 
        <span class="value days">
          {{ perShift[useByPaymentCapacity('weekly')].days.remaining | dayFormat }}
        </span>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import widgetHelper from "@/mixins/widgetHelper";
// import SendCongratulation from "@/mixins/send_congratulation";

export default {
  mixins: [widgetHelper],
  computed: {
    ...mapGetters(["streams"]),
    // neededPerDay() {
    //   if (!this.perShift.id) { return 0; }
    //   const weekly = this.perShift.weekly;

    //   let value = 0;
    //   if (this.settings.value.target_type === 'Count') {
    //     value = weekly.count;
    //   } else {
    //     value = weekly[this.useNetAmount()];
    //   }

    //   if (weekly.goal > value) {
    //     return (weekly.goal - value) / (weekly.days.remaining || 1);
    //   } else {
    //     return weekly.goal / weekly.days.working;
    //   }
    // },
    listeningAgents() {
      return this.perShift?.agents || [];
    },
  },
};
</script>